<script>
import { selectedAccount} from 'svelte-web3'
import Exchange from '../stores/Exchanage-contract-store'
import { orders } from '../stores/oders-store'

let orderFilling = false
let selected = false

const fillOrder = (id) => {
        selected = id
		$Exchange.methods.fillOrder(id).send({ from: $selectedAccount, gas: "1000000"})
		.on('transactionHash', (hash) => {
			orderFilling = true
		})
		.on('receipt', (bla) => {
			orderFilling = false
        })
		.on('error', (error) => {
            orderFilling = false
			console.log(error)
			window.alert('There was an error!')
		})
	}

</script>

{#if $orders && !orderFilling}
    {#await $orders.orderBookOrders then orders}
        <h6>Buy LTT</h6>
            <table class="table table-dark table-sm small">
                <tbody>
                    <tr>
                        <th>LTT</th>
                        <th>LTT/ETH</th>
                        <th>ETH</th>
                    </tr>
                    {#each orders.sellOrders as order}
                        <tr
                            key={order.id}
                            class="order-book-order"
                            class:selected = "{selected === order.id}"
                            on:click = {fillOrder(order.id)}
                        >
                            <td>{order.tokenAmount}</td>
                            <td
                                class={`text-${order.orderTypeClass}`}>
                                {order.tokenPrice}
                            </td>
                            <td>{order.etherAmount.toFixed(4)}</td>
                        </tr>
                    {/each}
                        <br />
                        <h6>Sell LTT</h6>
                            <tr>
                                <th>LTT</th>
                                <th>LTT/ETH</th>
                                <th>ETH</th>
                            </tr>
                    {#each orders.buyOrders as order}
                        <tr
                            key={order.id}
                            class="order-book-order"
                            class:selected = "{selected === order.id}"
                            on:click = {fillOrder(order.id)}
                        >
                            <td>{order.tokenAmount}</td>
                            <td
                                class={`text-${order.orderTypeClass}`}
                                >{order.tokenPrice}</td
                            >
                            <td>{order.etherAmount.toFixed(4)}</td>
                        </tr>
                    {/each}
                </tbody>
            </table>
    {/await}
{/if}

<style>
	.order-book-order.selected {
		text-decoration: line-through;
		color: white;
        outline:auto;
    }
</style>